import { useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Admin-side Aadhaar image upload.
 *  uploadSide(file, "front" | "back", isEdit = false) → { name, dob, address, aadhaarNo }
 * Throws an Error with a user-friendly message on failure.
 */
const useAadhaarImageUpload = (workerId) => {
  const [isUploading, setIsUploading] = useState(false);

  const uploadSide = async (file, side, isEdit = false) => {
    if (!workerId) throw new Error("Worker ID not found");
    const token = localStorage.getItem("superadmintoken");

    const formData = new FormData();
    formData.append("workerId", workerId);
    formData.append("side", side);
    if (isEdit === true) formData.append("isEdit", "true");
    formData.append("aadhaar_image", file);

    setIsUploading(true);
    try {
      const res = await fetch(`${BASE_URL}/lenskart/upload-aadhaar-image`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }, // no Content-Type for multipart
        body: formData,
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok || data.success === false) {
        throw new Error(data.message || data.error || "Could not read Aadhaar image. Try again.");
      }

      return {
        name: data.name || null,
        dob: data.dob || null,
        address: data.address || null,
        aadhaarNo: data.aadhaarNo || null,
      };
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadSide, isUploading };
};

export default useAadhaarImageUpload;